import { useArgusAuthContext } from "../contexts/ArgusAuthContext";

// Single seam over the auth provider: read auth state and trigger auth actions through this hook, not the
// provider context directly.
export const useArgusAuth = () => useArgusAuthContext();
